export default __webpack_public_path__ + "banner-card-icon4da4926.png";